import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList } from "vue";
const _hoisted_1 = { class: "row nav-item__todo" };
const _hoisted_2 = { class: "d-flex flex-row" };
const _hoisted_3 = { style: { "width": "35px", "min-width": "35px" } };
const _hoisted_4 = { class: "flex-fill" };
const _hoisted_5 = { key: 0 };
const _hoisted_6 = { key: 1 };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("svg", {
    class: /*#__PURE__*/ _normalizeClass('expand-icon__opened'),
    preserveAspectRatio: "xMidYMid meet",
    height: "1em",
    width: "1em",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    stroke: "currentColor"
}, [
    /*#__PURE__*/ _createElementVNode("g", null, [
        /*#__PURE__*/ _createElementVNode("polyline", { points: "9 18 15 12 9 6" })
    ])
], -1);
const _hoisted_8 = [
    _hoisted_7
];
const _hoisted_9 = {
    key: 2,
    class: "text-warning"
};
const _hoisted_10 = {
    key: 3,
    class: "text-success"
};
const _hoisted_11 = {
    key: 1,
    class: "text-muted d-flex flex-row"
};
const _hoisted_12 = { style: { "width": "35px", "min-width": "35px" } };
const _hoisted_13 = { class: "flex-fill" };
const _hoisted_14 = { key: 0 };
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("g", null, [
    /*#__PURE__*/ _createElementVNode("polyline", { points: "9 18 15 12 9 6" })
], -1);
const _hoisted_16 = [
    _hoisted_15
];
const _hoisted_17 = { key: 1 };
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("div", { class: "separator separator-dotted" }, null, -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_icon = _resolveComponent("g-icon");
    const _component_g_link = _resolveComponent("g-link");
    const _component_g_ozg_nav_item = _resolveComponent("g-ozg-nav-item", true);
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", {
                class: _normalizeClass(['col pt-2 pb-2', _ctx.currentPage?.name === _ctx.page.name ? 'fw-bolder' : ''])
            }, [
                (_ctx.page.isEnabled && _ctx.page.pageLink)
                    ? (_openBlock(), _createBlock(_component_g_link, {
                        key: 0,
                        src: _ctx.currentPage?.name === _ctx.page.name ? '' : _ctx.page.pageLink
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_2, [
                                _createElementVNode("div", _hoisted_3, [
                                    (_ctx.page.pageLevel < 3)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createTextVNode(_toDisplayString(_ctx.page.titleNumber), 1)
                                        ], 64))
                                        : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_4, [
                                    (_ctx.page.pageLevel >= 3)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createTextVNode(_toDisplayString(_ctx.page.titleNumber) + "  ", 1)
                                        ], 64))
                                        : _createCommentVNode("", true),
                                    _createTextVNode(" " + _toDisplayString(_ctx.page.title), 1)
                                ]),
                                (_ctx.page.pageType === 'multi')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                        _createVNode(_component_g_icon, {
                                            width: "16",
                                            height: "16",
                                            src: "/assets/icons/list.svg"
                                        })
                                    ]))
                                    : (_ctx.page.pageType === 'group')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
                                        : (_ctx.page.validationState === 'invalid')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                                _createVNode(_component_g_icon, {
                                                    width: "16",
                                                    height: "16",
                                                    src: "/assets/icons/exclamation-triangle.svg"
                                                })
                                            ]))
                                            : (_ctx.page.validationState === 'succeeded')
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                                    _createVNode(_component_g_icon, {
                                                        width: "16",
                                                        height: "16",
                                                        src: "/assets/icons/check-circle-fill.svg"
                                                    })
                                                ]))
                                                : _createCommentVNode("", true)
                            ])
                        ]),
                        _: 1
                    }, 8, ["src"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                            (_ctx.page.pageLevel < 3)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(_toDisplayString(_ctx.page.titleNumber), 1)
                                ], 64))
                                : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                            (_ctx.page.pageLevel >= 3)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(_toDisplayString(_ctx.page.titleNumber) + " ", 1)
                                ], 64))
                                : _createCommentVNode("", true),
                            _createTextVNode(_toDisplayString(_ctx.page.title), 1)
                        ]),
                        (_ctx.page.pageType === 'group')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                _createVNode(_component_g_link, { onLinkClick: _ctx.onExpand }, {
                                    default: _withCtx(() => [
                                        (_openBlock(), _createElementBlock("svg", {
                                            class: _normalizeClass([_ctx.isOpen ? 'expand-icon__opened' : 'expand-icon__closed']),
                                            height: "1em",
                                            width: "1em",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            viewBox: "0 0 24 24",
                                            "stroke-width": "2",
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round",
                                            stroke: "currentColor"
                                        }, _hoisted_16, 2))
                                    ]),
                                    _: 1
                                }, 8, ["onLinkClick"])
                            ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                _createVNode(_component_g_icon, {
                                    width: "16",
                                    height: "16",
                                    src: "/assets/icons/lock.svg"
                                })
                            ]))
                    ]))
            ], 2),
            _hoisted_18
        ]),
        (_ctx.page.pages && _ctx.page.pages.length > 0 && (_ctx.page.isEnabled || _ctx.page.elementType === 'group') && _ctx.isOpen)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.page.pages, (tsubpage) => {
                return (_openBlock(), _createBlock(_component_g_ozg_nav_item, {
                    page: tsubpage,
                    "current-page": _ctx.currentPage,
                    key: tsubpage.name
                }, null, 8, ["page", "current-page"]));
            }), 128))
            : _createCommentVNode("", true)
    ], 64));
}
